import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete, Visibility, Download } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";

function List(props) {
  const [mboList, setMboList] = useState([]);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );

  const isHR = utils.hasPermission(
    primaryMenuRes,
    "Sales Target",
    "sales_target.Hr_permissions"
  );

  const isSuperAdmin = utils.hasPermission(
    primaryMenuRes,
    "Sales Target",
    "sales_target.Super_Admin_permissions"
  );

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  const columns = [
    {
      name: "Year",
      selector: (row) => row.year,
      center: true,
      cell: (row) => {
        const currentYear = new Date().getFullYear(); // Get the current year
        const isCurrentYear = row.year === currentYear.toString(); // Check if the year is the current year
        console.log("IS this right", isCurrentYear, row.year, currentYear);
        return (
          <span style={{ fontWeight: isCurrentYear ? "bold" : "normal" }}>
            {row.year}
          </span>
        );
      },
    },
    {
      name: (
        <div className="text-center">
          Quarter 1 <br /> Target
        </div>
      ),
      selector: (row) => row.quarter_1,
      // cell: (row) => <div className="text-center">{row.quarter_1}</div>,
      center: true,
    },
    {
      name: (
        <div className="text-center">
          Quarter 2 <br /> Target
        </div>
      ),
      selector: (row) => row.quarter_2,
      center: true,
    },
    {
      name: (
        <div className="text-center">
          Quarter 3 <br /> Target
        </div>
      ),
      selector: (row) => row.quarter_3,
      center: true,
    },
    {
      name: (
        <div className="text-center">
          Quarter 4 <br /> Target
        </div>
      ),
      selector: (row) => row.quarter_4,
      center: true,
    },
    {
      name: (
        <div className="text-center">
          Yearly <br /> Target
        </div>
      ),
      selector: (row) => row.yearly,
      center: true,
    },

    {
      name: "View",
      cell: (row) => (
        <>
          <RB.Button
            className="btn-circle"
            variant="outline-primary"
            size="sm"
            onClick={isHR || isSuperAdmin ? handleHrView(row) : handleView(row)}
          >
            <Visibility />
          </RB.Button>
        </>
      ),
      center: true,
    },

    // {
    //   name: "Download",
    //   center: true,
    //   cell: (row) => (
    //     <>
    //       <RB.Button
    //         variant="outline-primary"
    //         size="sm"
    //         onClick={() => handleDownload(row)}
    //       >
    //         <Download />
    //       </RB.Button>
    //     </>
    //   ),
    // },
  ];

  useEffect(() => {
    getMboList();
  }, [page, userProfile?.id]);

  const getMboList = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("userId", userProfile?.id);
    bodyFormData.append("id", "");
    bodyFormData.append("page", page);
    bodyFormData.append("per_page", countPerPage);

    utils
      .callAPI("get", `/sales/getmbolist`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setMboList(res);
        } else {
          setMboList([]);
        }
      })
      .catch((err) => {
        setMboList([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleHrView = useCallback((row) => async () => {
    const propdata = {
      mode: "HrView",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/getDelete?id=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getMboList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  // const handleDownload = (row) => {
  //   window.open(row.document_link, "_blank");
  // };

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action">
            {utils.hasPermission(
              primaryMenuRes,
              "Sales Target",
              "sales_target.create"
            ) && (
              <RB.Button
                className="btn btn-primary me-2"
                onClick={handleAddClick}
              >
                Add Target
              </RB.Button>
            )}
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          {utils.hasPermission(
            primaryMenuRes,
            "Sales Target",
            "sales_target.view"
          ) && (
            <DataTable
              columns={columns}
              data={mboList}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={mboList.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              striped
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              // subHeader
              // subHeaderComponent={subHeaderComponent}
            />
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
